import { render, staticRenderFns } from "./MoveCdp.vue?vue&type=template&id=85b1a0be&scoped=true&"
import script from "./MoveCdp.vue?vue&type=script&lang=js&"
export * from "./MoveCdp.vue?vue&type=script&lang=js&"
import style0 from "./MoveCdp.vue?vue&type=style&index=0&id=85b1a0be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b1a0be",
  null
  
)

export default component.exports